import { STATES } from '../../../constants';
import { actions, selectors } from '../../../state';

const ERROR_MESSAGE = `The link to reset your password expired. Don't worry, we can
  send you another one now, just enter your email below.`;

export function ResetConfig($stateProvider) {
  'ngInject';
  return $stateProvider.state(STATES.FORGOT_PASSWORD_RESET, {
    url: '^/reset-password/{resetToken}',
    views: {
      '@': {
        template: '<upd-forgot-password-reset></upd-forgot-password-reset>',
        // controller is here so we wait for `isTokenValid` to resolve
        controller: isTokenValid => {},
      },
    },
    analytics: {
      page: 'Reset Password',
    },
    data: {
      permissions: 'anyone',
    },
    resolve: {
      resetToken: $stateParams => $stateParams.resetToken,
      isTokenValid: (resetToken, updStore) => {
        const { dispatch } = updStore;

        const handleSignOut = () => {
          if (selectors.session.isSignedIn(updStore.getState())) {
            return dispatch(actions.session.clear());
          }
        };

        const error = () => {
          dispatch(actions.router.stateGo(STATES.FORGOT_PASSWORD));
          dispatch(actions.message.error(ERROR_MESSAGE));
        };

        return dispatch(actions.passwordReset.singleton(resetToken).read())
          .then(handleSignOut)
          .catch(error);
      },
    },
  });
}
